import { registerPlugin } from '@capacitor/core'
import type { UserInterfaceStylePlugin } from './definitions'

const UserInterfaceStyle = registerPlugin<UserInterfaceStylePlugin>('UserInterfaceStyle')

export * from './definitions'
export { UserInterfaceStyle }
